/**
 * Created by hj on 2017/9/12.
 */
import {
    config,
    request,
} from 'Utils';

/**
 * 订单列表-完成
 * @param param
 * @returns {*}
 */
export function getOrderList(param) {
    return request(`${config.server}/api/v1/dms/tgOrder/list`, {
        method: 'post',
        body: param,
    });
}

/**
 * 下浮设置-列表
 * @param param
 * @returns {*}
 */
export function getLowerList(param) {
    return request(`${config.server}/api/v1/dms/trans/rate/listByPage`, {
        method: 'post',
        body: param,
    });
}

/*渠道接口*/
export function fetchChannelList() {
    return request(`${config.server}/api/v1/dms/homePage/channel`, {
        method: 'get',
    });
}

/*获取产品动态参数*/
export function getDongList(param) {
    return request(`${config.server}/api/v1/dms/tgOrder/getOrderProParam2`, {
        method: 'post',
        body: param,
    });
}

/*获取产品动态参数*/
export function getDongList2(param) {
    return request(`${config.server}/api/v1/dms/tgOrder/getOrderProParam`, {
        method: 'post',
        body: param,
    });
}

/**
 * 二级客户订单列表-完成
 * @param param
 * @returns {*}
 */
export function getOrderList2(param) {
    return request(`${config.server}/api/v1/dms/trans/order/list`, {
        method: 'post',
        body: param,
    });
}

/**
 * 订单详情-完成
 * @param param
 * @returns {*}
 */
export function getOrderDetails(param) {
    return request(`${config.server}/api/v1/dms/tgOrder/detail`, {
        method: 'post',
        body: param,
    });
}

/*选择物料搜索-完成*/
export function getPro(param) {
    return request(`${config.server}/api/v1/dms/product/listPc`, {
        method: 'post',
        body: param,
    });
}

/*选择省市搜索-完成*/
export function getPro2(param) {
    return request(`${config.server}/api/v1/dms/tgOrder/getOrderProvinceCity`, {
        method: 'post',
        body: param,
    });
}

/*选择省市搜索-完成*/
export function getPro3(param) {
    return request(`${config.server}/api/v1/dms/tgOrder/getOrderSubsidiary`, {
        method: 'post',
        body: param,
    });
}

/*选择省市搜索-完成*/
export function getPro4(param) {
    return request(`${config.server}/api/v1/dms/tgOrder/specialList`, {
        method: 'post',
        body: param,
    });
}

/*选择省市搜索-完成*/
export function getPro5(param) {
    return request(`${config.server}/api/v1/dms/tgOrder/specialLineList`, {
        method: 'post',
        body: param,
    });
}

/*项目订单选择合同/订单类型-完成*/
export function getPro6(param) {
    return request(`${config.server}/api/v1/dms/dmsErpCredit/directSellContract`, {
        method: 'post',
        body: param,
    });
}

/*点击提交按钮*/
export function create(param) {
    return request(`${config.server}/api/v1/dms/tgOrder/createOrder`, {
        method: 'post',
        body: {...param},
    });
}

/*点击保存按钮*/
export function createForSave(param) {
    return request(`${config.server}/api/v1/dms/tgOrder/saveOrder`, {
        method: 'post',
        body: {...param},
    });
}

/*项目订单点击保存提交按钮*/
export function create2(param) {
    return request(`${config.server}/api/v1/dms/tgOrder/createProjectOrder`, {
        method: 'post',
        body: {...param},
    });
}

/**
 * 更新订单行信息
 * @param param
 * @returns {*}
 */
export function updateOrderLineAttribute(getProCode) {
    return request(`${config.server}/api/v1/dms/tgOrder/updateOrderLineAttribute?getProCode=${getProCode}`, {
        method: 'get',
    });
}

/*二级客户订单点击保存提交按钮*/
export function createSecondOrder(param) {
    return request(`${config.server}/api/v1/dms/trans/order/createSecondOrder`, {
        method: 'post',
        body: {...param},
    });
}

/*新增订单数据详情*/
export function getDetail(param, param2) {
    // return request(`${config.server}/api/v1/dms/tgOrder/getCusByCode?code=${param}`, {
    return request(`${config.server}/api/v1/dms/tgOrder/getCusById?purchaseId=${param}&thirdId=${param2}`, {
        method: 'post',
        body: param,
    });
}

/**
 *
 * 订单审核
 * @param param
 * @returns {*}
 */
export function getOrderApprove(param) {
    return request(`${config.server}/api/v1/dms/order/audit`, {
        method: 'post',
        body: param,
    });
}

/**
 * 订单 收款确认
 * @param param
 * @returns {*}
 */
export function orderPayConfirm(param) {
    return request(`${config.server}/api/v1/dms/order/payConfirm`, {
        method: 'post',
        body: param,
    });
}

/**
 * 订单 操作日志
 * @param param
 * @returns {*}
 */
export function getOrderLog(orderId, relatedType) {
    return request(`${config.server}/api/v1/dms/order/operationLog?id=${orderId}&relatedType=${relatedType ? relatedType : 1}&sort=0`, {
        method: 'get',
    });
}

/**
 * 订单 获取发货清单 初始数据
 * @param param
 * @returns {*}
 */
export function getSendProduct(orderId) {
    return request(`${config.server}/api/v1/dms/order/productStorage?id=${orderId}`, {
        method: 'get',
    });
}

/**
 * 订单 发货
 * @param param
 * @returns {*}
 */
export function orderSendSave(param) {
    return request(`${config.server}/api/v1/dms/orderDelivery/insert`, {
        method: 'post',
        body: param,
    });
}

/**
 * 订单 获取付款证明
 * @param param
 * @returns {*}
 */
export function getPayProve(id) {
    return request(`${config.server}/api/v1/dms/order/payDetail?id=${id}`, {
        method: 'get',
    });
}

/**
 * 订单 获取品牌商仓库的产品可用量
 * @param param
 * @returns {*}
 */
export function getStorageAvailable(params) {
    return request(`${config.server}/api/v1/dms/storageInventory/count`, {
        method: 'post',
        body: params,
    });
}

/*待发货列表接口*/
export function getShippedList(param) {
    return request(`${config.server}/api/v1/dms/tgOrder/waitDeliverList
`, {
        method: 'post',
        body: param,
    });
}

/*已发货列表接口*/
export function getstayList(param) {
    return request(`${config.server}/api/v1/dms/tgOrder/yetDeliverList`, {
        method: 'post',
        body: param,
    });
}

/*提货地址*/
export function getTiAddress(cusId, purchaseId) {
    return request(`${config.server}/api/v1/dms/tgOrder/getAddressByCusId?cusId=${cusId}&purchaseId=${purchaseId}`, {
        method: 'get',
    });
}

/*下浮价*/
export function getXia(param) {
    return request(`${config.server}/api/v1/dms/tgOrder/discount`, {
        method: 'post',
        body: param,
    });
}

/*删除*/
export function idDelete(param) {
    return request(`${config.server}/api/v1/dms/tgOrder/deleteOrder?orderId=${param}`, {
        method: 'post',
    });
}

/*刷新状态*/
export function refreshStatus(param) {
    return request(`${config.server}/api/v1/dms/tgOrder/refreshStatus?orderId=${param}`, {
        method: 'post',
    });
}

/*获取分批发运*/
export function getFenPi(param) {
    return request(`${config.server}/api/v1/dms/tgOrder/orderProPartDetails`, {
        method: 'post',
        body: param,
    });
}

/*项目订单特价传值*/
export function giveTeJia(param) {
    return request(`${config.server}/api/v1/dms/tgOrder/selectProSpecial`, {
        method: 'post',
        body: param,
    });
}

/*项目订单特价传值2*/
export function giveTeJia2(param) {
    return request(`${config.server}/api/v1/dms/tgOrder/selectProSpecial2`, {
        method: 'post',
        body: param,
    });
}

/*获取预订单行*/
export function getReserve(param) {
    return request(`${config.server}/api/v1/dms/tgOrder/selectProReserve`, {
        method: 'post',
        body: param,
    });
}

/*保存分批发运*/
export function insertFenPi(param) {
    return request(`${config.server}/api/v1/dms/tgOrder/insterOrderProPart`, {
        method: 'post',
        body: param,
    });
}

/*获取评价*/
export function orderEvaluationInsert(param) {
    return request(`${config.server}/api/v1/dms/orderEvaluation/insert`, {
        method: 'post',
        body: param,
    });
}

/*批量设置提货地点*/
export function getTiHuo(param) {
    return request(`${config.server}/api/v1/dms/product/listPc`, {
        method: 'post',
        body: param,
    });
}

/**
 * 分批发运详情
 * */
export function orderProPartDetails(param) {
    return request(`${config.server}/api/v1/dms/tgOrder/orderProPartDetails`, {
        method: 'post',
        body: param,
    });
}

/**
 * 客户确认
 * */
export function confirmOrder(param) {
    return request(`${config.server}/api/v1/dms/tgOrder/confirmOrder`, {
        method: 'post',
        body: param,
    });
}

/**
 * 待客户确认
 * */
export function waitForConfirm(param) {
    return request(`${config.server}/api/v1/dms/tgOrder/cusSubmitOrder`, {
        method: 'post',
        body: param,
    });
}

/**
 * 驳回
 * */
export function waitForConfirmCancle(param) {
    return request(`${config.server}/api/v1/dms/tgOrder/cusrefuseOrder`, {
        method: 'post',
        body: param,
    });
}

/**
 * 订单列表-完成
 * @param param
 * @returns {*}
 */
export function getOwning(param) {
    return request(`${config.server}/api/v1/dms/orderReport/oweGoods`, {
        method: 'post',
        body: param,
    });
}

/**
 * 驳回后提交
 * @param param
 * @returns {*}
 */
export function giveBefore(param) {
    return request(`${config.server}/api/v1/dms/tgOrder/beforeSubmitOrder`, {
        method: 'post',
        body: param,
    });
}

/**
 * 特价详情头信息
 * @param param
 * @returns {*}
 */
export function specialPageLineList(param) {
    return request(`${config.server}/api/v1/dms/tgOrder/specialPageLineList`, {
        method: 'post',
        body: param,
    });
}

/**
 * 特价详情行信息
 * @param param
 * @returns {*}
 */
export function specialHeadList(param) {
    return request(`${config.server}/api/v1/dms/tgOrder/specialDetail`, {
        method: 'post',
        body: param,
    });
}

/**
 * 取消发货
 * @param param
 * @returns {*}
 */
export function leaveFa(param) {
    return request(`${config.server}/api/v1/dms/tgOrder/dropOrderLine`, {
        method: 'post',
        body: param,
    });
}

export function getEscrow(param) {
    return request(`${config.server}/api/v1/dms/tgOrder/getEscrow`, {
        method: 'post',
        body: param,
    });
}

export function getEscrowDetail(param) {
    return request(`${config.server}/api/v1/dms/tgOrder/getEscrowDetail`, {
        method: 'post',
        body: param,
    });
}

/*购货单位搜索*/
export function getGdList(param) {
    return request(`${config.server}/api/v1/dms/dmsErpCredit/gdList`, {
        method: 'post',
        body: param,
    });
}

/*购货单位查询*/
export function fetchGouHuo() {
    return request(`${config.server}/api/v1/dms/dmsPurchase/selectByCusList`, {
        method: 'get',
    });
}

/**
 * 发货管理
 * @param param
 * @returns {*}
 */
export function getDelivery(param) {
    return request(`${config.server}/api/v1/dms/orderReport/Delivery`, {
        method: 'post',
        body: param,
    });
}

/******************* 商品选型库 start *********************/
/** 获取各个状态的订单数量
 * @returns {*}
 */
export function getOrderStatusCount() {
    return request(`${config.server}/api/v1/order/count`);
}

/**
 * 订单列表
 * @param param
 * @returns {*}
 */
export function getFinishedOrderList(param) {
    return request(`${config.server}/api/v1/order/getFinished`, {
        method: 'post',
        body: param,
    });
}

/**
 * 订单列表
 * @param param
 * @returns {*}
 */
export function getuserOrderList(param) {
    return request(`${config.server}/api/v1/order/userlist`, {
        method: 'post',
        body: param,
    });
}

/**
 * 订单 评价详情
 * @param param
 * {
 *    orderId,
 *    orderProductId
 * }
 * @returns {*}
 */
export function getOrderEvaluation(param) {
    return request(`${config.order_server}/api/v1/orderEvaluation/detail`, {
        method: 'get',
        body: param,
    });
}

/**
 * 订单 新增评价
 * @param param
 * {
 *  "productEvaluationList":[
 *    {"score":5,"content":"www","picFileIdList":[178],"orderId":242,"orderProductId":321}
 *  ],
 *  "logisticsEvaluation":{"packScore":5,"speedScore":5,"attitudeScore":5}
 * }
 * @returns {*}
 */
export function insertOrderEvaluation(param) {
    return request(`${config.order_server}/api/v1/orderEvaluation/insert`, {
        method: 'post',
        body: param,
    });
}

/**
 * 订单 再来一单
 * @param param
 * @returns {*}
 */
export function orderAgain(params) {
    return request(`${config.server}/api/v1/order/again`, {
        method: 'post',
        body: params,
    });
}

/**
 *  获取-是否支持0库存下单allowReservation\是否显示库存量showInventory
 * @returns {*}
 */
export function getProductGlobalVariablesFn() {
    return request(`${config.server}/api/v1/dms/common/globalVariables`);
}

/**
 * 订单 确认收货
 * @param param
 * @returns {*}
 */
export function confirmReceive(params) {
    return request(`${config.server}/api/v1/dms/order/confirm`, {
        method: 'post',
        body: params,
    });
}

/**
 * 订单 已发货的单个产品确认收货
 * @param param
 * @returns {*}
 */
export function confirmReceiveSignal(params) {
    return request(`${config.server}/api/v1/dms/orderDelivery/confirm`, {
        method: 'post',
        body: params,
    });
}

/**
 * 订单 取消订单
 * @param param
 * @returns {*}
 */
export function cancelOrder(params) {
    return request(`${config.server}/api/v1/order/cancel`, {
        method: 'post',
        body: params,
    });
}

/**
 * 订单 订单付款
 * @param param
 * @returns {*}
 */
export function payOrder(params) {
    return request(`${config.server}/api/v1/order/pay`, {
        method: 'post',
        body: params,
    });
}

/**
 * 订单 收款详情
 * @param param
 * @returns {*}
 */
export function payDetail(orderId) {
    return request(`${config.server}/api/v1/order/payDetail?id=orderId`);
}

/**
 * 二级客户结算页，获取发货仓库
 * @param param
 * @returns {*}
 */
export function firstChannelListByPage(params) {
    return request(`${config.server}/api/v1/dms/dmsTianSubStore/firstChannelListByPage`, {
        method: 'post',
        body: {
            'removeFlag': 0,
            's': 1000,
            'p': 1,
            ...params,
        },
    });
}

/**
 * 订单详情--商品跟踪
 * @param param
 * @returns {*}
 */
export function getOrderLineTrack(lineId) {
    return request(`${config.server}/api/v1/dms/tgOrder/getOrderLineTrack`, {
        method: 'get',
        body: {
            lineId: lineId
        },
    });
}

/******************* 商品选型库 end *********************/



// WEBPACK FOOTER //
// ./src/service/order/index.js